export default {
  bankOptions: state => state.bankOptions,
  navItems: state => state.navItems,
  filterItems: state => state.filterItems,
  paymentMethods: state => state.paymentMethods,
  isLoaded: state => state.loaded
}
